<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <div>
      <!-- dialog common header -->
      <popup-header
        v-bind:headerSaveBtn="headerSaveBtnName"
        v-on:clickSave="doSave"
        v-on:clickClose="closeModal()"
      ></popup-header>
      <!-- 제목 -->
      <v-row class="title-wrap">
        <v-col cols="12" class="big-title">참조자 추가</v-col>
      </v-row>
      <!-- 추가버튼 -->
      <v-row class="ma-0 mb-3">
        <v-col cols="12" class="py-0 px-6">
          <v-btn
            color="white"
            block
            height="48"
            elevation="0"
            class="btn-add"
            @click="onOffModal(callModalName)"
          >
            참조자 추가
            <v-icon class="ml-auto" color="#a4abb2">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- 참조자 리스트 -->
      <v-row class="ma-0">
        <v-col class="px-6 pt-2">
          <v-list class="order-list">
            <draggable v-model="referUserListCopy" handle=".drag-handle">
              <v-list-item-group
                v-for="referItem in referUserListCopy"
                :key="referItem.referSabun"
              >
                <v-list-item class="px-4">
                  <v-list-item-icon @click="deleteEmp(referItem)">
                    <v-icon>mdi-close</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      ><span class="name" v-text="referItem.name"></span
                      ><span
                        class="sub-desc ml-2"
                        v-text="referItem.referJikchak"
                      ></span
                      ><span
                        class="sub-desc divider"
                        v-text="referItem.referOrg"
                      ></span
                    ></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-icon class="ml-auto drag-handle">
                    <v-icon>mdi-menu</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list-item-group>
            </draggable>
          </v-list>
        </v-col>
      </v-row>

      <!-- [모달] 임직원검색 -->
      <search-executives-dialog
        v-on:clickEmpSelect="addEmp"
      ></search-executives-dialog>
    </div>
  </v-dialog>
</template>

<script>
import SearchExecutivesDialog from '@/components/application/dialog/SearchExecutivesDialog.vue'; // 임직원검색 modal component
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component

import { mapGetters } from 'vuex';
import Draggable from 'vuedraggable';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    referUserListProps: {
      type: [],
    },
  },
  data: () => ({
    modalName: 'add_referrer',
    callModalName: 'search_executives',
    headerSaveBtnName: '추가',
    referUserListCopy: [],
  }),
  watch: {
    // 현재참조자목록 복사 (props로 받은 값은 변경할 수 없음)
    referUserListProps() {
      this.referUserListCopy = this.referUserListProps;
    },
  },
  computed: {
    ...mapGetters('ELA', ['GET_APPL_USER_LIST']),
  },
  methods: {
    /* 결재선 임직원추가 */
    addEmp(employee) {
      // 중복검사
      const dupResult = this.referUserListCopy.filter(
        user => user.referSabun == employee.sabun,
      );

      if (dupResult != '') {
        alert('이미 참조자로 추가된 임직원입니다');
        return;
      }

      // 참조자에 추가
      this.referUserListCopy.push({
        agreeSeq: '1',
        name: employee.name,
        referSabun: employee.sabun,
        referJikwee: employee.jikweeNm,
        referJikchak: employee.jikchakNm,
        referOrg: employee.orgNm,

        inSabun: this.GET_APPL_USER_LIST[0].agreeSabun,
        inOrg: this.GET_APPL_USER_LIST[0].org,
        inJikchak: this.GET_APPL_USER_LIST[0].jikchak,
        inJikwee: this.GET_APPL_USER_LIST[0].jikwee,
      });

      // 모달닫기
      this.onOffModal(this.callModalName);
    },

    /* 결재선 임직원삭제 */
    deleteEmp(employee) {
      this.referUserListCopy.forEach((item, index) => {
        if (item.referSabun == employee.referSabun) {
          this.referUserListCopy.splice(index, 1);
        }
      });
    },

    /* 변경내용저장 */
    doSave() {
      this.$store.commit('ELA/SET_REFER_USER_LIST', this.referUserListCopy);
      this.closeModal();
    },

    /* 모달호출 */
    onOffModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },
  },
  components: {
    PopupHeader,
    SearchExecutivesDialog,
    Draggable,
  },
};
</script>
<style>
.v-btn.btn-add {
  border-radius: 12px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  font-size: 1rem;
}
</style>
